import { 
	createRenderBubble,
	makeAssistantMsg,
	sendMessages,
	prepareUserMessage,
	updateMsgContent,
	updateMsgHistory,
	scrollMsgsContainerDown,
	removeMsg
} from "./chat.js";
import specialViewMap from "./specialViewMap.js";

export function getSpecialViewFromMsg(msg) {
	const sep = "front_special_view";
	if(msg.indexOf(sep) == -1) {
		return false;
	}

	let parts = msg.split(sep);
	if(parts.length < 2) {
		return false;
	}


	let resultContainer = document.createElement("div");
	resultContainer.classList.add("special-view-container");

	for(let i=1; i<parts.length; i++) {
		let specialView = parts[i].trim();

		let textarea = document.createElement('textarea');
		textarea.innerHTML = specialView;

		specialView = textarea.value;
		if(!specialView) {
			continue;
		}

		specialView = JSON.parse(specialView);

		if(typeof specialViewMap[specialView.special_view] == "undefined") {
			continue;
		}

		resultContainer.appendChild(specialViewMap[specialView.special_view](specialView.data));
	}

	return resultContainer;
}

export function doQuestionEventHandler(e) {
	const self = e.currentTarget;
	const question = self.dataset.doQuestion;

	const chat = document.querySelector(".chat-container");
	chat.appendChild(createRenderBubble("user", true, question).message);

	const msgid = makeAssistantMsg();
	sendMessages(
		msgid,
		prepareUserMessage(question), 
		function(resp, msgid){
			if(resp["status"] != "done") {
				return;
			}

			let specialViewContent = getSpecialViewFromMsg(resp["content"]);
			let content = resp["content"].split("front_special_view")[0].trim();
			if(content.length) {
				content = marked.parse(content).trim();
				updateMsgContent(msgid, content);
			} else {
				removeMsg(msgid);
			}

			if(specialViewContent) {
				document.querySelector(".chat-container").appendChild(specialViewContent);
				updateMsgHistory();
			}

			updateMsgHistory();
			scrollMsgsContainerDown();
		}
	);
}

export function initIdentificationCard(authCard) {
	const kbAuthPhoneField = authCard?.querySelector("#kb-phone");
	const kbAuthBtn = authCard?.querySelector("button.kb-auth-btn");

	kbAuthPhoneField?.addEventListener("input", e => {
		e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '');
		let val = e.currentTarget.value;

		if(val.length < 9) {
			kbAuthBtn.classList.add("disabled");
		} else {
			kbAuthBtn.classList.remove("disabled");
		}
	});

	kbAuthBtn?.addEventListener("click", e => {
		const phone = kbAuthPhoneField.value;
		kbAuthBtn.classList.add("disabled");

		const msgid = makeAssistantMsg();
		const req = "[номер телефона в формате json из формы идентификации пользователя, теперь ты можешь загрузить данные о пользователе с помощью инструмента]" + JSON.stringify({"phone": phone});

		sendMessages(
			msgid,
			prepareUserMessage(req), 
			function(resp, msgid){
				if(resp["status"] != "done") {
					kbAuthBtn.classList.remove("disabled");
					return;
				}
				
				let content = marked.parse(resp["content"]).trim();

				const btnContainer = kbAuthBtn.parentNode;
				kbAuthBtn.remove();
				const div = document.createElement("div");
				div.innerHTML = `<span class="kb-btn large kb-auth-btn disabled">Відправлено</span>`;
				btnContainer.appendChild(div.querySelector("span"));

				updateMsgContent(msgid, content);
				updateMsgHistory();
			}
		);
	});
}

export function initEventCard(card) {
	card.querySelector(".reg-to-event").addEventListener("click", e => {
		const data = JSON.parse(e.currentTarget.dataset.json);
		console.log("REG", data);
		
		const card = specialViewMap.registrationCard({
			type: "course",
			data: data
		});

		const chat = document.querySelector(".chat-container");
		chat.appendChild(card);
		updateMsgHistory();
		scrollMsgsContainerDown();
	});
}

export function initRegistrationCard(card) {
	if(!card.classList.contains("kb-signup-card")) {
		card = card.querySelector(".kb-signup-card");
	}

	const type = card.dataset.type;
	const submitBtn = card.querySelector(".send-form");

	// validation
	let formFields = [
    ...card.querySelectorAll("input"),
    ...card.querySelectorAll("select")
	];

	function updateSubmitBtnState(fields, btn) {
		let flag = true;
		for(let i of fields) {
			if(i.classList.contains("inp-error") || i.classList.contains("noinput")) {
				// console.log("field validation err", i);
				flag = false;
			}
		}

		if(flag) {
			btn.classList.remove("disabled");
		} else {
			btn.classList.add("disabled");
		}
	}

	const kbPhoneField = card.querySelector(`input[name="phone"]`);
	kbPhoneField?.addEventListener("input", e => {
		e.currentTarget.classList.remove("noinput");
		e.currentTarget.value = e.currentTarget.value.replace(/\D/g, '');
		let val = e.currentTarget.value;

		if(val.length < 9) {
			kbPhoneField.classList.add("inp-error");
		} else {
			kbPhoneField.classList.remove("inp-error");
		}

		updateSubmitBtnState(formFields, submitBtn);
	});

	card.querySelectorAll("input").forEach(i => {

		if(i.name != "phone" && i.type != "hidden") {
			i.addEventListener("input", e => {
				i.classList.remove("noinput");
				if(e.currentTarget.value.length < 2) {
					e.currentTarget.classList.add("inp-error");
				} else {
					e.currentTarget.classList.remove("inp-error");
				}

				updateSubmitBtnState(formFields, submitBtn);
			});
		}

		if(i.type != "hidden") {
			if(i.value.length < 2) {
				i.classList.add("noinput");
			}
		}
	});

	card.querySelectorAll("select").forEach(i => {

		if(!i.classList.contains("hide")) {
			i.addEventListener("change", e => {
				i.classList.remove("noinput");
				if(e.currentTarget.value == 0) {
					e.currentTarget.classList.add("inp-error");
				} else {
					e.currentTarget.classList.remove("inp-error");
				}

				updateSubmitBtnState(formFields, submitBtn);
			});
		}

		if(!i.classList.contains("hide")) {
			if(i.value.length < 2) {
				i.classList.add("noinput");
			}
		}
	});

	card.querySelector(`[name="city"]`).addEventListener("change", e => {
		if(e.currentTarget.value == "Київ") {
			card.querySelector(".district-container").classList.remove("hide");
		} else {
			card.querySelector(".district-container").classList.add("hide");
		}
	});

	// end of validation

	submitBtn?.addEventListener("click", e => {
		if(e.currentTarget.classList.contains("disabled")) {
			return;
		}

		const fields = {
			type: type
		};
		for(let input of formFields) {
			fields[input.name] = input.value;
		}

		if(fields.additional != "undefined" && fields.additional.length) {
			fields.additional = JSON.parse(fields.additional);
		}

		fields.phone = "380" + fields.phone;

		console.log("Registration", fields);
		submitBtn.classList.add("disabled");

		const msgid = makeAssistantMsg();
		sendMessages(
			msgid,
			prepareUserMessage(JSON.stringify(fields)), 
			function(resp, msgid){
				if(resp["status"] != "done") {
					submitBtn.classList.remove("disabled");
					return;
				}
				
				const btnContainer = submitBtn.parentNode;
				submitBtn.remove();
				const div = document.createElement("div");
				div.innerHTML = `<span class="kb-btn large kb-auth-btn disabled">Відправлено</span>`;
				btnContainer.appendChild(div.querySelector("span"));

				let content = marked.parse(resp["content"]).trim();
				updateMsgContent(msgid, content);
				updateMsgHistory();
			}
		);
	});
}

export function initSpecialButton(btn) {
	btn.addEventListener("click", e => {
		if(e.currentTarget.dataset.href) {
			document.location = e.currentTarget.dataset.href;
			return;
		}
	});
}

export function initInteractiveElsEvents(chat) {
	chat.querySelectorAll("[data-do-question]").forEach(i => {
		i.addEventListener("click", e => {
			doQuestionEventHandler(e);
		});
	});

	initIdentificationCard(chat?.querySelector(".kb-auth-card"));

	chat.querySelectorAll(".kb-event-card").forEach(i => {
		initEventCard(i);
	});

	chat.querySelectorAll(".kb-signup-card").forEach(i => {
		initRegistrationCard(i);
	});

	chat.querySelectorAll(".kb-btn").forEach(i => {
		initSpecialButton(i);
	});
}